import React, { ReactElement } from 'react';

export type MultipleSelectListboxDividerProps = {
  showDivider: boolean;
};

export function MultipleSelectListboxDivider({
  showDivider,
}: MultipleSelectListboxDividerProps): ReactElement {
  if (!showDivider) {
    return <></>;
  }

  return (
    <li className="dropdown__divider" role="presentation" aria-hidden="true" />
  );
}
